import { createContext, useContext } from "react";
import type { AdminStatus } from "./types";
import { assert } from "@/helpers/helpers";

export const AdminContext = createContext<AdminStatus | undefined>(undefined);

export function useAdminContext() {
  const res = useContext(AdminContext);
  assert(res);
  return res;
}
